import React, { useCallback, useRef } from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import CarouselCard from "./CarouselCard/CarouselCard";
import TonalIconContainer from "./TonalIconContainer";
import { ControlsConfig, MARGIN_15, PackageCarouselConfig } from "../package-carousel.props";
import { EqualHeight } from "react-equal-height/clean";
import useCardWidth from "./useCardWidth";

const styles = {
  cardsContainerStyles: {
    display: "flex",
    overflow: "auto",
    py: "16px",
    scrollBehavior: "smooth",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": { display: "none" }
  }
};

export interface CardsProps {
  cards: any[];
  myFreeConfig?: any;
  config?: PackageCarouselConfig;
  controlsConfig?: ControlsConfig;
}

const Cards = (props: CardsProps) => {
  const { cards, myFreeConfig, config, controlsConfig } = props;
  const scrollRef = useRef<HTMLDivElement>(null);
  const cardWidth = useCardWidth();

  const handlePrev = useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -cardWidth - MARGIN_15,
        behavior: "smooth"
      });
    }
  }, [cardWidth]);

  const handleNext = useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: cardWidth + MARGIN_15,
        behavior: "smooth"
      });
    }
  }, [cardWidth]);

  return (
    <DtvBox aria-label="Package carousel" aria-roledescription="carousel" overflow="hidden" role="region" sx={{
 m: {
 xs: "0 20px 0 20px",
sm: "0 32px 0 32px",
md: "0 140px 0 140px"
}
}}>
      <EqualHeight>
        <DtvBox ref={scrollRef} sx={{ ...styles.cardsContainerStyles }}>
          {cards?.map((card, index) => (
              <CarouselCard
                card={card}
                cardWidth={cardWidth}
                index={index}
                key={index}
                {...(card?.config?.type === "modal" && {
                  myFreeConfig
                })}
              />
            ))}
        </DtvBox>
      </EqualHeight>
      {/* Controls */}
      <TonalIconContainer
        config={config}
        controlsConfig={controlsConfig}
        handleNext={handleNext}
        handlePrev={handlePrev}
      />
    </DtvBox>
  );
};

export default React.memo(Cards);
